import { apiPath, type StreamCheck, StreamCheckSchema } from '@codot/contracts';
import { request } from './http';

/** Streaming video app: the server checks a stream link answers and is a stream (HLS / DASH / a video file). */
export const streamApi = {
  check: (url: string): Promise<StreamCheck> => request('GET', `${apiPath('streamCheck')}?url=${encodeURIComponent(url)}`, StreamCheckSchema),
};
